import React from 'react';
import { Result, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useI18n } from '../hooks/useI18n';

const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useI18n();

  return (
    <Result
      status="403"
      title="403"
      subTitle={t('error.unauthorized') || '抱歉，您无权访问此页面。'}
      extra={
        <Button type="primary" onClick={() => navigate('/')}>
          {t('common.backHome') || '返回首页'}
        </Button>
      }
    />
  );
};

export default Unauthorized;
